import { Tracker } from "./tracker";
import { Customer } from "./customer";

export class Vehicle {
    id: number;
    name: string;
    plate: string;
    brand: string;
    model: string;
    color: string;
    cc: number;
    type: string;
    species: string;
    fuel: string;
    yMod: string;
    yFab: string;
    renavam: string;
    seal: string;
    chassi: string;
    odometer: number;
    tracker: Tracker;
    customer: Customer;
    photo: string;
    minWeight:number;
    maxWeight:number;
    maxVelocity:number;
    
    logisticCost:number;

    constructor(id: number, name: string,
        plate: string, brand: string,
        model: string, color: string,
        cc: number, type: string, species: string, fuel: string,
        yMod: string, yFab: string, renavam: string, seal: string,
        chassi: string, odometer: number, tracker: Tracker,
        customer: Customer,photo: string, minWeight:number, maxWeight:number, maxVelocity:number) {

            this.id = id;
            this.name = name;
            this.plate = plate;
            this.brand = brand;
            this.model = model;
            this.color = color;
            this.cc = cc;
            this.type = type;
            this.species = species;
            this.fuel = fuel;
            this.yMod = yMod;
            this.yFab = yFab;
            this.renavam = renavam;
            this.seal = seal;
            this.chassi = chassi;
            this.odometer = odometer;
            this.tracker = tracker;
            this.customer = customer;
            this.photo = photo;
            this.minWeight = minWeight;
            this.maxWeight = maxWeight;
            this.maxVelocity = maxVelocity;

    }

    get fullName():string {
        if (this.plate && this.name && this.name != this.plate) {
            return this.plate + ' (' + this.name + ')';
        }
        else {
            return this.plate;
        }        
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/entities/vehicle.ts